import { createContext } from "react";

const ScrollDirectionContext = createContext<"up" | "down">("up");

export default ScrollDirectionContext;
